class Prefixs {
    static LOCK_UNPAID = "/certificate/lock/unpaid";
    static LOCK_NOT_ENOUGH_DOC = "/certificate/lock/notenoughdoc";
    static RENEWCERT = "/support/fc/renewcert";
    static RENEWCERT_ERROR = "/support/fc/renewcert-error";
    static RENEWCERT_INFO = "/support/fc/step-rncertinfo";
    static LOCK_REVOKE = "/certificate/lock/revoke";
    static LOCK_AUTHEN = "/certificate/lock/autheninfo";
    static LOCK_WRONG_PIN = "/tokengw/unlock";
    static TOKEN_GATEWAY = "/tokengw/open";
    static EXPIRES = "/expires";
    static NOTFOUND = "/notfound";
    static RESET_PIN_AUTHENTICATED = "/tokengw/resetpin";
    static RESET_PIN_NOTAUTHENTICATED = "/tokengw/resetpin/notauthenticated";
    static SERVICE_REGISTER = "/tokengw/add";
    static SERVICE_EXTEND = "/tokengw/extent";
    static SUPPORT_CHANGE_INFO = "/tokengw/support/changeinfo";
    static SUPPORT_CHANGE_INFO_CONFIRM = "/tokengw/support/changeinfo/confirm";
    static SUPPORT_REQUEST = "/tokengw/support";
    static SUPPORT_ADD_INFO = "/tokengw/support-add";
    static UNLOCK_SUCCSES = "/tokengw/unlock/success";
    static RESET_PIN_SUCCSES = "/tokengw/resetpin/success";
    static NOTI_NOT_ENOUGH_DOC = "/certificate/notification/notenoughdoc";
    static NOTI_EXTEND = "/certificate/notification/extend";
    static VIEW_FILE_TUTORIAL = "/tutorial";
    static LOOK_UP_SUPPORT = "/tokengw/look-up-support";
    static ORDER_PAYMENT = "/order-payment";
    static COMPENSATION_EXTEND = "/compensation-extend";

    static PATH_PUBLIC_CAPBU = "/tokengw/tra-cuu-cap-bu";
    static PATH_MESSAGE_PAGE = "/tokengw/message";
  }
  
  export default Prefixs;
  